import { Link } from "react-router-dom";
import { cookieConsent } from "./CookieConsent";

export default function Footer() {
  const openCookiePrefs = () => cookieConsent.reopen();
  return (
    <footer
      data-testid="site-footer"
      className="mt-24 border-t border-slate-200 bg-[#F9FAFB]"
    >
      <div className="lulo-container py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2 md:col-span-1">
            <img
              src="/logo-full.png"
              alt="Lulo Software"
              className="h-12 w-auto"
              width="1451"
              height="356"
              decoding="async"
              loading="lazy"
            />
            <p className="mt-5 text-sm text-slate-600 leading-6 max-w-xs">
              Decision-support software for professionals across e-commerce
              compliance, skincare reference, and market research.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500">
              Company
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link data-testid="footer-link-about" className="text-slate-700 hover:text-[#0A2540]" to="/about">About</Link></li>
              <li><Link data-testid="footer-link-products" className="text-slate-700 hover:text-[#0A2540]" to="/products">Products</Link></li>
              <li><Link data-testid="footer-link-pricing" className="text-slate-700 hover:text-[#0A2540]" to="/pricing">Pricing</Link></li>
              <li><Link data-testid="footer-link-contact" className="text-slate-700 hover:text-[#0A2540]" to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500">
              Trust
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link data-testid="footer-link-trust" className="text-slate-700 hover:text-[#0A2540]" to="/trust">Trust Center</Link></li>
              <li><Link data-testid="footer-link-security" className="text-slate-700 hover:text-[#0A2540]" to="/security">Security</Link></li>
              <li><Link data-testid="footer-link-subprocessors" className="text-slate-700 hover:text-[#0A2540]" to="/subprocessors">Subprocessors</Link></li>
              <li><Link data-testid="footer-link-dpa" className="text-slate-700 hover:text-[#0A2540]" to="/dpa">DPA</Link></li>
              <li><Link data-testid="footer-link-responsible-use" className="text-slate-700 hover:text-[#0A2540]" to="/responsible-use">Responsible Use</Link></li>
              <li><Link data-testid="footer-link-ai-policy" className="text-slate-700 hover:text-[#0A2540]" to="/ai-policy">AI Usage Policy</Link></li>
              <li><Link data-testid="footer-link-data-handling" className="text-slate-700 hover:text-[#0A2540]" to="/data-handling">Data Handling</Link></li>
              <li><Link data-testid="footer-link-platform-independence" className="text-slate-700 hover:text-[#0A2540]" to="/platform-independence">Platform Independence</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500">
              Legal
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link data-testid="footer-link-terms" className="text-slate-700 hover:text-[#0A2540]" to="/terms">Terms of Service</Link></li>
              <li><Link data-testid="footer-link-privacy" className="text-slate-700 hover:text-[#0A2540]" to="/privacy">Privacy Policy</Link></li>
              <li><Link data-testid="footer-link-refund" className="text-slate-700 hover:text-[#0A2540]" to="/refund-policy">Refund Policy</Link></li>
              <li><Link data-testid="footer-link-aup" className="text-slate-700 hover:text-[#0A2540]" to="/acceptable-use">Acceptable Use Policy</Link></li>
              <li>
                <button
                  type="button"
                  onClick={openCookiePrefs}
                  data-testid="footer-link-cookie-settings"
                  className="text-slate-700 hover:text-[#0A2540] text-left p-0 bg-transparent border-0 cursor-pointer"
                >
                  Cookie Settings
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500">
              Contact
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-slate-700">
              <li><a data-testid="footer-email-support" className="hover:text-[#0A2540]" href="mailto:support@lulosoftware.com">support@lulosoftware.com</a></li>
              <li><a data-testid="footer-email-legal" className="hover:text-[#0A2540]" href="mailto:legal@lulosoftware.com">legal@lulosoftware.com</a></li>
              <li className="text-slate-600 leading-6">
                Lulo Software LLC<br />
                30 N Gould St, Ste R<br />
                Sheridan, WY 82801, USA
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-slate-500">
            © 2026 Lulo Software LLC. All rights reserved.
          </p>
          <p className="text-xs text-slate-500">
            Registered in Wyoming, USA · Operations in Hyderabad, India
          </p>
        </div>
      </div>
    </footer>
  );
}
